import React from 'react';
import '../assets/App.scss';
import '../assets/globalStyles.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPen} from '@fortawesome/free-solid-svg-icons';

const CardDetailOrder = (props) => {
  return (
    <div className="columns is-mobile mr-0">
      <div onClick={props.handleUpdate} className="column is-narrow is-1 purple">
        <FontAwesomeIcon icon={faPen} />
      </div>

      <div className="column">
        <p className="font-medium has-text-black">
            {props.food}
        </p>
        <p className="font-small">{props.option}</p>
        <p className="font-small">{props.extra}</p>
        <p className="text-bold font-medium">Rp {props.price}</p>
      </div>

      <div className="column-left is-centered px-1 py-2">
        <button
          className="button decrement"
          onClick={props.handleDecrease}
        >
          <p className="icon-minus">-</p>
        </button>

        <strong className="font-size is-centered px-2">{props.quantity}</strong>

        <button
          className="button increment"
          onClick={props.handleIncrease}
        >
          <p className="icon-plus">+</p>
        </button>

      </div>

    </div>
  )
}

export default CardDetailOrder;
